import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

// at the time of writing, this component is not used

const Health = () => {
  const HEALTH_QUERY = gql`
    {
      healthCheck
    }
  `;

  const queryResult = useQuery(HEALTH_QUERY);

  const { error, loading, data } = queryResult;

  if (error) return <>error: {JSON.stringify(error)}</>;
  if (loading) return <>loading</>;
  if (data && data.healthCheck && data.healthCheck.length > 0 && data.healthCheck[0] === 1) return <>healthy</>;
};

export default Health;
